module.exports = __webpack_public_path__ + "assets/img/11_830_big.51e501bb.jpg";